import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "../../../stripe";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import CardForm from "./card-form";
import StripeIcon from "../../../assets/icons/stripe.svg";

const CardInfoModal = (props) => {

  /**
   * on toggle modal
   */
  const toggle = () => {
    props.setShowCardInfoModal(false);
  };

  

  return (
    <>
      <Modal className="billing_modal" isOpen={true} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Complete Your Payment, your payment is protected with Stripe ( <img src={StripeIcon} alt="Stripe Payment" style={{width:'20px'}} />)
        </ModalHeader>
        <ModalBody className="p-0">
          <Elements 
            stripe={stripePromise}
            options={{
              appearance: { theme: "stripe" },
            }}>
            <CardForm
              getUserAndPlans={props.getUserAndPlans} 
              onClose={toggle} 
              selectedPlan={props.selectedPlan}
              planPeriodType={props.planPeriodType}
            />
          </Elements>
        </ModalBody> 
      </Modal>
    </>  
  )

}

export default CardInfoModal;